import { scrambledCls, containerCls, iconCls } from './atom.scrambled.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function Scrambled() {
  return /*#__PURE__*/jsx("div", {
    className: scrambledCls,
    children: /*#__PURE__*/jsx("div", {
      className: containerCls,
      children: /*#__PURE__*/jsxs("svg", {
        className: iconCls,
        version: "1.1",
        viewBox: "0 0 28.1 38.8",
        xmlns: "http://www.w3.org/2000/svg",
        children: [/*#__PURE__*/jsx("path", {
          d: "M7,13.5c0.3,0,0.5-0.2,0.5-0.5v-1.7C7.8,11.2,8,10.9,8,10.5c0-0.6-0.4-1-1-1s-1,0.4-1,1c0,0.4,0.2,0.7,0.5,0.8V13C6.5,13.3,6.7,13.5,7,13.5z M7,10.5C7,10.5,7,10.5,7,10.5C7,10.5,7,10.5,7,10.5l-0.5,0L7,10.5z"
        }), /*#__PURE__*/jsx("path", {
          d: "M13,8v4.5c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5v-5C14,7.2,13.8,7,13.5,7H12V5c0-2.8-2.2-5-5-5S2,2.2,2,5v2H0.5C0.2,7,0,7.2,0,7.5v10C0,17.8,0.2,18,0.5,18h1C1.8,18,2,17.8,2,17.5S1.8,17,1.5,17H1V8H13z M3,5c0-2.2,1.8-4,4-4s4,1.8,4,4v2H3V5z"
        }), /*#__PURE__*/jsx("path", {
          d: "M27.5,14.7h-23c-0.3,0-0.6,0.3-0.6,0.6v23c0,0.3,0.3,0.6,0.6,0.6h23c0.3,0,0.6-0.3,0.6-0.6v-23C28.1,14.9,27.8,14.7,27.5,14.7z M26.9,37.7H5.1V15.8h21.9V37.7z"
        }), /*#__PURE__*/jsxs("g", {
          children: [/*#__PURE__*/jsx("path", {
            d: "M16.8,31.5c-0.2-0.1-0.3-0.2-0.5-0.2c-0.9-0.4-1.9-0.2-2.5,0.6c-0.3,0.3-0.2,0.6,0.2,0.7c1.5,0.7,3,1.4,4.5,2.1c1.2,0.6,2.5,0.4,3.5-0.4c1.1-0.8,1.5-1.9,1.4-3.2c0-0.3-0.1-0.5-0.2-0.8c-0.2-0.5-0.4-1-0.6-1.6c-0.2-0.4-0.5-0.7-0.9-0.8l-2.3-0.4c-0.1,0-0.2,0-0.2,0c-0.5-0.1-1,0.1-1.2,0.6c0,0,0,0,0,0.1c0-0.1,0-0.1-0.1-0.1c-0.2-0.7-0.5-1.3-0.7-2c-0.2-0.6-0.8-0.9-1.4-0.7c-0.6,0.2-0.8,0.8-0.6,1.4c0.6,1.5,1.1,3,1.7,4.5L16.8,31.5L16.8,31.5z"
          }), /*#__PURE__*/jsx("path", {
            d: "M13.4,22.2c0.1,0.3,0.4,0.4,0.7,0.3l0.9-0.3c0.3-0.1,0.4-0.4,0.3-0.7l-1.1-2.8c-0.1-0.3-0.4-0.4-0.7-0.3l-0.9,0.3c-0.3,0.1-0.4,0.4-0.3,0.7L13.4,22.2z"
          }), /*#__PURE__*/jsx("path", {
            d: "M17,21.5c-0.1,0.3,0,0.6,0.3,0.7l0.8,0.4c0.3,0.1,0.6,0,0.7-0.3c0,0,0,0,0,0l1.2-2.7c0.1-0.3,0-0.6-0.3-0.7c0,0,0,0,0,0L19,18.6c-0.3-0.1-0.6,0-0.7,0.3c0,0,0,0,0,0L17,21.5z"
          }), /*#__PURE__*/jsx("path", {
            d: "M23.6,24.5c0.3-0.1,0.4-0.4,0.3-0.7l-0.3-0.9c-0.1-0.3-0.4-0.4-0.7-0.3L20,23.6c-0.3,0.1-0.4,0.4-0.3,0.7c0,0,0,0,0,0l0.3,0.9c0.1,0.3,0.4,0.4,0.7,0.3L23.6,24.5z"
          }), /*#__PURE__*/jsx("path", {
            d: "M12,28.8c0.3-0.1,0.4-0.4,0.3-0.7L12,27.2c-0.1-0.3-0.4-0.4-0.7-0.3L8.4,28c-0.3,0.1-0.4,0.4-0.3,0.7l0.3,0.9c0.1,0.3,0.4,0.4,0.7,0.3L12,28.8z"
          }), /*#__PURE__*/jsx("path", {
            d: "M9.4,22.2c-0.3-0.1-0.6,0-0.7,0.3l-0.4,0.8c-0.1,0.3,0,0.6,0.3,0.7l2.8,1.2c0.3,0.1,0.6,0,0.7-0.3l0.3-0.8c0.1-0.3,0-0.6-0.3-0.7L9.4,22.2z"
          })]
        })]
      })
    })
  });
}

export { Scrambled };
//# sourceMappingURL=atom.scrambled.js.map
